import {
  ColumnDef,
  ColumnFiltersState,
  SortingState,
} from "@tanstack/react-table";

export const buildLinqFilter = (
  status: string,
  columnFilters: any[],
  globalSearch?: string,
): string => {
  console.log("1. Raw Column Filters:", JSON.stringify(columnFilters));

  let parts: string[] = [`Status == "${status}"`];

  columnFilters.forEach((f) => {
    const { id, value } = f;

    const applyFilter = (op: string, val: any, type?: string) => {
      if (val === "" || val === null || val === undefined) return null;

      if (type === "date") {
        if (op === "before") return `${id} <= DateOnly.Parse("${val}")`;
        if (op === "after") return `${id} >= DateOnly.Parse("${val}")`;
        if (op === "equals") return `${id} == DateOnly.Parse("${val}")`;
      }

      if (type === "datetime") {
        if (op === "before") return `${id} <= DateTime.Parse("${val}")`;
        if (op === "after") return `${id} >= DateTime.Parse("${val}")`;
        if (op === "equals") return `${id} == DateTime.Parse("${val}")`;
      }

      // NUMBER LOGIC: Ensure no quotes around ${val}
      if (type === "number") {
        if (op === "greater_than") return `${id} >= ${val}`;
        if (op === "less_than") return `${id} <= ${val}`;
        if (op === "equals") return `${id} == ${val}`;
        return null; // Stop here for numbers
      }

      // STRING LOGIC
      switch (op) {
        case "contains":
          return `${id}.Contains("${val}")`;
        case "not_contains":
          return `!${id}.Contains("${val}")`;
        case "equals":
          return `${id} == "${val}"`;
        case "starts_with":
          return `${id}.StartsWith("${val}")`;
        case "ends_with":
          return `${id}.EndsWith("${val}")`;
        default:
          return null;
      }
    };

    if (Array.isArray(value)) {
      value.forEach((v) => {
        const part = applyFilter(v.operator, v.value, v.type);
        if (part) parts.push(part);
      });
    } else if (value?.operator) {
      const part = applyFilter(value.operator, value.value, value.type);
      if (part) parts.push(part);
    }
  });

  if (globalSearch) {
    parts.push(
      `(TicketNumber.Contains("${globalSearch}") || VendorID.Contains("${globalSearch}"))`,
    );
  }
  return parts.join(" && ");
};

export const buildLinqSort = (sorting: SortingState): string => {
  if (!sorting.length) return "";
  return sorting.map((s) => `${s.id} ${s.desc ? "desc" : "asc"}`).join(", ");
};
